<template>
  <div>
    <header class="header-box">
      <div class="avator">
        <el-image
          class="avator-img"
          :src="avatar"
          shape="circle"
          :preview-src-list="[avatar]"
        >
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
        </el-image>
        <i
          class="QS-icon-import download"
          @click.stop.prevent="downloadImage"
          v-if="isRealAvatar"
        ></i>
      </div>
      <div class="info-box">
        <div>
          {{ userInfo.userName }}
          <el-tag :type="userInfo.state ? 'success' : 'error'">{{
            state
          }}</el-tag>
        </div>
        <div>
          员工账号：{{ userInfo.userAccount
          }}{{ `@${userInfo.tenantShortName}` }}
        </div>
      </div>
    </header>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>基础信息</span>
      </div>
      <div class="card-content">
        <div class="card-content-item">
          <div>手机号</div>
          <div>{{ userInfo.userMobile }}</div>
        </div>
        <div class="card-content-item">
          <div>钉钉组织绑定</div>
          <div>{{ userInfo.dingOrgName }}</div>
        </div>
        <div class="card-content-item">
          <div>所属部门</div>
          <div>
            <TextOverTooltip
              :content="userInfo.deptName"
              placement="top-start"
              style="margin-right: 0px"
            />
          </div>
        </div>
        <div class="card-content-item">
          <div>角色权限</div>
          <div>
            <el-tag v-for="(item, index) in userInfo.roleList" :key="index">{{
              item.name
            }}</el-tag>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { downloadImgURL } from '@/utils/download'
import imageUrl from '@/assets/img/default_user_image.png'

const props = defineProps({
  userInfo: {
    type: Object,
    default: () => ({
      name: '',
      avatar: '',
    }),
  },
})

const state = computed(() => {
  return props.userInfo.state ? '启用中' : '禁用中'
})
const isRealAvatar = computed(() => props.userInfo.avatar?.length)
const avatar = computed(() => {
  return props.userInfo.avatar?.[0]?.url || imageUrl
})

const downloadImage = () => {
  downloadImgURL(avatar.value, '头像')
}
</script>
<style scoped lang="scss">
::v-deep(.el-card) {
  border: 0 none;
}
::v-deep(.el-card__header) {
  border-bottom: 0 none;
}
::v-deep(.el-tag) {
  height: 24px;
  width: auto !important;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  padding: 0 8px;
  border-radius: 4px;
  opacity: 1;
  box-sizing: border-box;
  border: 1px solid #e8f2ff;
}
.avator-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.card-content {
  flex: 1;
  display: grid;
  height: auto;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: min-content;
  border-radius: 8px;
  opacity: 1;
  box-sizing: border-box;
  /* 线框/line-grayBlue3 */
  /* 样式描述：实线分割线、边框 */
  border: 1px solid #e7e8eb;
  background: #e7e8eb;
  grid-gap: 1px;
  overflow: hidden;
  &-item {
    padding: 8px 16px;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    width: 263px;
    letter-spacing: 0em;
    background: #fff;
    max-height: 380px;
    display: flex;
    flex-direction: column;
    > div:first-child {
      color: rgba(0, 0, 0, 0.6);
      margin-bottom: 10px;
    }
    > div:last-child {
      color: rgba(0, 0, 0, 0.9);
      flex: 1;
      overflow: auto;
    }
  }
}
.header-box {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 20px;
  padding: 12px 16px;
  background-color: #fff;
  margin-bottom: 8px;
}
.info-box {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  flex-direction: column;
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  > div:first-child {
    color: rgba(0, 0, 0, 0.9);
    font-size: 16px;
    font-weight: 500;
  }
  > div:last-child {
    color: rgba(0, 0, 0, 0.6);
  }
}

::v-deep(.el-tag--small) {
  font-size: 12px;
  font-weight: normal;
  height: 22px;
  margin-bottom: 4px;
  margin-right: 4px;
}
.other {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.expls {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 247px;
  margin-right: 5px;
  cursor: pointer;
}
.num {
  cursor: pointer;
  color: #366cfe;
}
.avator {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  position: relative;
  .download {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    cursor: pointer;
    font-size: 14px;
    background: #fff;
  }
}
.line {
  flex-direction: row;
  max-width: 247px;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
}
</style>
